import { useEffect } from 'react';
import { ErrorBoundary, StatusBanner } from '@templates/index';
import { useAppStore, usePerfStore, useAudioStore, useHandStore } from '@store/index';
import { CameraStage } from '@features/instrument';
import { SettingsDrawer } from '@features/settings';
import { TuningDrawer } from '@features/tuning';
import { SynthDrawer } from '@features/synth';
import { TransportDrawer } from '@features/transport';
import './App.css';

/** Tiny floating telemetry (bottom-left). */
function Telemetry() {
  const fps = usePerfStore((s) => s.fps);
  const latency = useAudioStore((s) => s.latencyMs);
  const cameraError = useHandStore((s) => s.cameraError);
  return (
    <div className="telemetry">
      <span>{fps.toFixed(0)} fps</span>
      <span>{latency} ms</span>
      {cameraError && (
        <span style={{ color: '#ff6b6b', maxWidth: '60vw', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          ⚠ {cameraError}
        </span>
      )}
    </div>
  );
}

export default function App() {
  const status = useAppStore((s) => s.status);
  const errorMessage = useAppStore((s) => s.errorMessage);
  const check = useAppStore((s) => s.checkCompatibility);

  useEffect(() => {
    check();
  }, [check]);

  const playable = status === 'ready' || status === 'boot';

  return (
    <div className="app-root">
      <ErrorBoundary>
        {playable ? (
          <CameraStage />
        ) : (
          <div className="app-root__fallback">
            <StatusBanner
              tone={status === 'unsupported' ? 'warning' : 'error'}
              title={
                status === 'unsupported'
                  ? 'Browser compatibility issue'
                  : 'Startup error'
              }
            >
              {errorMessage ?? 'Please use a modern Chromium or Safari browser.'}
            </StatusBanner>
          </div>
        )}
      </ErrorBoundary>
      {playable && <Telemetry />}
      <SettingsDrawer />
      <TuningDrawer />
      <SynthDrawer />
      <TransportDrawer />
    </div>
  );
}
